import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { selectABSCurrentSettings, setDefaultSettings } from 'app/store/abs/settingsSlice';
import _ from '@lodash';
import useThemeMediaQuery from '@abs/hooks/useThemeMediaQuery';
import { navbarToggle, navbarToggleMobile, selectABSNavbar } from 'app/store/abs/navbarSlice';
import ABSSvgIcon from '@abs/core/ABSSvgIcon';
import { useTranslation } from 'react-i18next';

function NavbarToggleButton(props) {
  const dispatch = useDispatch();
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));
  const settings = useSelector(selectABSCurrentSettings);
  const navbar = useSelector(selectABSNavbar);
  const { config } = settings.layout;
  const { t } = useTranslation('abslayouts');

  let isOpen;
  if (isMobile) {
    isOpen = navbar.mobileOpen;
  } else if (config.navbar.style === 'style-2') {
    isOpen = !config.navbar.folded;
  } else {
    isOpen = navbar.open;
  }

  const tooltip = isOpen ? t('NAVBAR_CLOSE') : t('NAVBAR_OPEN');

  return (
    <Tooltip title={tooltip} placement="bottom">
    <IconButton
      className={props.className}
      color="inherit"
      size="small"
      onClick={(ev) => {
        if (isMobile) {
          dispatch(navbarToggleMobile());
        } else if (config.navbar.style === 'style-2') {
          //this one lags in firefox dev
          dispatch(
            setDefaultSettings(
              _.set({}, 'layout.config.navbar.folded', !settings.layout.config.navbar.folded)
            )
          );
        } else {
          dispatch(navbarToggle());
        }
      }}
    >
      {isOpen ? (
        <ABSSvgIcon size={20} color="inherit">first_page</ABSSvgIcon>
      ) : isMobile ? (
        <ABSSvgIcon size={20} color="inherit">heroicons-outline:view-list</ABSSvgIcon>
      ) : (
        <ABSSvgIcon size={20} color="inherit">last_page</ABSSvgIcon>
      )}
    </IconButton>
    </Tooltip>
  );
}

NavbarToggleButton.defaultProps = {};

export default NavbarToggleButton;
